import { Fragment, useCallback } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import parse from "html-react-parser";
import { _oldSelectImageForDevice } from "../../utils";
import { SiteContext } from "../Contexts/SiteContext";
import { hasProperty } from "../../utils/validate";
import HeaderButtons from "./Buttons/header-buttons";

const LazyLoad = dynamic(() => import('./Image/LazyLoad'));

const DefaultBanner = ({ banner }) => {
	const handleClick = useCallback((e) => {
		if (!e.target.classList.contains('waves-effect')) {
			const bannerLink = banner.image.bannerLink

			if (bannerLink) {
				if (bannerLink.target === '_blank') {
					window.open(bannerLink.url);
				} else {
					window.location.href = bannerLink.url;
				}
			}
		}
	}, [banner]);

	if (!banner) {
		return;
	}

	return (
		<SiteContext.Consumer>
			{({ deviceType }) => (
				<Fragment>
					<div className="banner" onClick={handleClick}>
						<div className="imageHolder">
							<div className="overlay">
								{banner.image.overseasModelShown ? (
									<h6 className="disc">*Overseas model shown</h6>
								) : null}
							</div>
							<LazyLoad
								// className={"responsive-img"}
								// (!isMobile) ? banner.image: isMobile && !Array.isArray(banner.mobile) && banner.mobile.length !== 0 ? banner.mobile : banner.image
								image={_oldSelectImageForDevice(deviceType, banner)}
								alt={banner.title}
								title={banner.title}
							/>
						</div>
						<div className="productBannerCopyHolder">
							<div className={`productBannerCopy ${banner.title == null ? 'no-copy' : ''}`}>
								{banner.title != null &&
									<div className={`copy`}>
										<div className="line" />
										{banner.title &&
											<h1>{banner.title}</h1>}
										{hasProperty(banner, "description") && banner.description != null &&
											<h6>{parse(banner.description)}</h6>}
									</div>
								}

								{banner && banner.buttons && banner.buttons !== null && banner.buttons.length > 0 &&
									<HeaderButtons buttons={banner.buttons} />}

								{/* old buttons */}
								{banner.link != null && (
									<div className="buttons">
										{banner.link.type != null && banner.link.type == "Entry" ? (
											<Link href={`/${banner.link.uri}`}>
												<a
													title={banner.link.text}
													className="waves-effect waves-light btn-large bbred">
													{banner.link.text}
												</a>
											</Link>
										) : (
											<a
												title={banner.link.text}
												href={banner.link.url}
												className="waves-effect waves-light btn-large bbred">
												{banner.link.text}
											</a>)
										}

										{hasProperty(banner, "secondary") && banner.secondary != null ? ( // check property secondary exist
											banner.secondary.type == "Entry" ? (
												<Link href={`/${banner.secondary.uri}`}>
													<a
														title={banner.secondary.text}
														className="waves-effect waves-light btn-large bbwhite">
														{banner.secondary.text}
													</a>
												</Link>
											) : (
												<a
													title={banner.secondary.text}
													href={banner.secondary.url}
													className="waves-effect waves-light btn-large bbwhite">
													{banner.secondary.text}
												</a>
											)
										) : null}
									</div>)
								}
							</div>
						</div>
					</div>
				</Fragment>
			)}
		</SiteContext.Consumer>
	);
};

export default DefaultBanner;